var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0756397 0.372083L4.80138 5.91054C4.82594 5.93683 4.85646 5.95794 4.89085 5.97241C4.92523 5.98689 4.96266 5.99438 5.00053 5.99438C5.03841 5.99438 5.07583 5.98689 5.11022 5.97241C5.1446 5.95794 5.17513 5.93683 5.19969 5.91054L9.92543 0.372083C9.95489 0.338163 9.97322 0.297337 9.97829 0.254323C9.98337 0.211308 9.97499 0.167862 9.95412 0.129006C9.93309 0.0902801 9.90062 0.0576696 9.86037 0.0348401C9.82012 0.0120111 9.77368 -0.000132084 9.72627 -0.00022459L0.274796 -0.00022459C0.227389 -0.000132084 0.18095 0.0120111 0.140699 0.0348401C0.10045 0.0576696 0.0679827 0.0902801 0.0469475 0.129006C0.0260792 0.167862 0.0176983 0.211308 0.0227757 0.254323C0.027853 0.297337 0.0461807 0.338163 0.0756397 0.372083Z",
    fill: "#B20838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoss);
export default __webpack_public_path__ + "static/media/loss.322460b3ebd203f0c7645ca1c477309c.svg";
export { ForwardRef as ReactComponent };